module.exports = __webpack_public_path__ + "img/03logo-tee2021.82f5cdf4.png";